// Copyright (c) Ergoss Logiciels - All rights reserved - Proprietary and confidential
// Copyright (c) Ergoss Logiciels - All rights reserved - Proprietary and confidential
export enum TransKey {
  // Actions
  Action_title = 'USER SETTINGS.Action',
  Action_menu_title = 'NAVIGATION MENU.Action Tracking',
  Action_col_title = 'VIEW.ACTION TRACKING.ARRAY.Title',
  Action_col_description = 'VIEW.ACTION TRACKING.ARRAY.Description',
  Action_col_Linked_ac = 'VIEW.ACTION TRACKING.ARRAY.Linked to AC',
  Action_col_Date = 'VIEW.ACTION TRACKING.ARRAY.Date',
  Action_col_Linked_assets = 'VIEW.ACTION TRACKING.ARRAY.Linked to Assets',
  Action_col_Linked_snaps = 'VIEW.ACTION TRACKING.ARRAY.Linked to Snapshot',
  Action_col_Linked_events = 'VIEW.ACTION TRACKING.ARRAY.Linked to Events',
  Action_col_Tags = 'VIEW.ACTION TRACKING.ARRAY.Tags',
  Action_filter_Type_title = 'VIEW.ACTION TRACKING.FILTERS.Type',
  Action_Add_filter = 'VIEW.ACTION TRACKING.Add Filter',

  // Aircrafts
  Aircraft_Airline = 'VIEW.AIRCRAFTS.AIRCRAFT.Airline',
  Aircraft_Registration = 'VIEW.AIRCRAFTS.AIRCRAFT.Registration',
  Aircraft_Fleet = 'VIEW.AIRCRAFTS.AIRCRAFT.Fleet',
  Aircraft_Type = 'VIEW.AIRCRAFTS.AIRCRAFT.Type',
  Aircraft_Engines = 'VIEW.AIRCRAFTS.AIRCRAFT.Engines',
  Aircraft_SerialNumber = 'VIEW.AIRCRAFTS.AIRCRAFT.SerialNumber',
  Aircraft_Manufacturer = 'VIEW.AIRCRAFTS.AIRCRAFT.Manufacturer',
  Aircrfat_MTOW = 'VIEW.AIRCRAFTS.AIRCRAFT.MTOW',
  Aircraft_MLW = 'VIEW.AIRCRAFTS.AIRCRAFT.MLW',

  Aircraft_add = 'VIEW.AIRCRAFTS.Add Aircraft',
  Aircraft_add_failure = 'MESSAGE.ERROR.Unable to create Aircraft',
  Aircraft_add_success = 'MESSAGE.SUCCESS.Aircraft created',
  Aircraft_all = 'VIEW.AIRCRAFTS.AIRCRAFT.All',
  Aircraft_edit_failure = 'MESSAGE.ERROR.Unable to edit Aircraft',
  Aircraft_edit_success = 'MESSAGE.SUCCESS.Aircraft edited',
  Aircraft_new_title = 'VIEW.AIRCRAFTS.NEW AIRCRAFT.Title',
  Aircraft_no_longer_ope = 'VIEW.AIRCRAFTS.AIRCRAFT.NoLongerOperational',
  Aircraft_non_ope = 'VIEW.AIRCRAFTS.AIRCRAFT.Non-operational',
  Aircraft_ope = 'VIEW.AIRCRAFTS.AIRCRAFT.Operational',

  Aircraft_title = 'VIEW.AIRCRAFTS.Title',
  Aircraft_view = 'VIEW.AIRCRAFTS.AIRCRAFT.',
  Aircrafts_menu_title = 'NAVIGATION MENU.Aircrafts',
  Aircraft_label = 'VIEW.REPORTS.UPLOAD.Aircraft',

  Aircraft_Warning_changes = 'VIEW.AIRCRAFTS.AIRCRAFT.Warning changes',
  Aircraft_Registration_len = 'VIEW.AIRCRAFTS.AIRCRAFT.Registration length',
  Aircraft_Registration_exists = 'VIEW.AIRCRAFTS.AIRCRAFT.Registration exists',
  Aircraft_Msn = 'VIEW.AIRCRAFTS.AIRCRAFT.Msn',
  Aircraft_Type_dash = 'VIEW.AIRCRAFTS.AIRCRAFT.Type dash',
  Aircraft_Pwi_fleet = 'VIEW.AIRCRAFTS.AIRCRAFT.PWI fleet',
  Aircraft_End_of_service = 'VIEW.AIRCRAFTS.AIRCRAFT.End of Service',
  Aircraft_Creation_date = 'VIEW.AIRCRAFTS.AIRCRAFT.Creation date',
  Aircraft_In_service = 'VIEW.AIRCRAFTS.AIRCRAFT.In service',
  Aircraft_filter_In_service = 'VIEW.AIRCRAFTS.FILTER.In service filter',
  Aircraft_filter_Out_of_service = 'VIEW.AIRCRAFTS.FILTER.Out of service filter',
  Aircraft_Irreversible_action = 'VIEW.AIRCRAFT.Irreversible action',
  Aircraft_No_ope_warning = 'VIEW.AIRCRAFT.No ope warning',
  Aircraft_No_ope_revert_msg = 'VIEW.AIRCRAFT.No ope revert message',

  // Assets
  Assets_menu_title = 'NAVIGATION MENU.Assets Tracking',
  Assets_add = 'VIEW.ASSETS.Add',
  Assets_aircraft = 'VIEW.ASSETS.Aircraft',
  Assets_aircraft_current = 'VIEW.ASSETS.Current Aircraft',
  Assets_array_aircraft = 'VIEW.ASSETS.ARRAY.Aircraft',
  Assets_array_desc = 'VIEW.ASSETS.ARRAY.Description',
  Assets_array_position = 'VIEW.ASSETS.ARRAY.Position',
  Assets_array_Sn = 'VIEW.ASSETS.ARRAY.S/N',
  Assets_array_type = 'VIEW.ASSETS.ARRAY.Type',
  Assets_by_aircraft = 'VIEW.ASSETS.Search Assets by Aircraft',
  Assets_by_Sn = 'VIEW.ASSETS.Search Assets by S/N',
  Assets_by_type = 'VIEW.ASSETS.Search Assets by Types',
  Assets_delete = 'VIEW.ASSETS.Delete Asset',
  Assets_delete_confirm = 'VIEW.ASSETS.Are you sure you want to delete this asset ?',
  Assets_desc = 'VIEW.ASSETS.Description',
  Assets_edit_desc = 'VIEW.ASSETS.Edit Description',
  Assets_end_date = 'VIEW.ASSETS.End Date',
  Assets_manage_types = 'VIEW.ASSETS.Manage Types',
  Assets_position = 'VIEW.ASSETS.Position',
  Assets_registration = 'VIEW.ASSETS.Registration',
  Assets_search = 'VIEW.ASSETS.Assets search',
  Assets_since = 'VIEW.ASSETS.Since',
  Assets_Sn = 'VIEW.ASSETS.S/N',
  Assets_start_date = 'VIEW.ASSETS.Start Date',
  Assets_table = 'VIEW.ASSETS.Assets table',
  Assets_timeline = 'VIEW.ASSETS.TIMELINE',
  Assets_title = 'VIEW.ASSETS.Title',
  Assets_type_delete_confirm = 'VIEW.ASSETS.Are you sure you want to delete this asset type ?',
  Assets_type_add = 'VIEW.ASSETS.Add Type',
  Assets_type = 'VIEW.ASSETS.Type',
  Assets_label = 'VIEW.ASSETS.Asset label',
  Assets_Type_edit = 'VIEW.ASSETS.Edit type',
  Assets_Type_already_exists = 'VIEW.ASSETS.Type already exists',
  Assets_Type_update_confirm = 'VIEW.ASSETS.Type update confirm',
  Assets_Assignment_to_close = 'VIEW.ASSETS.Active assignment to close',
  Assets_Start_overlap = 'VIEW.ASSETS.Start date overlap',
  Assets_End_overlap = 'VIEW.ASSETS.End date overlap',
  Assets_Assignment_no_close = 'VIEW.ASSETS.Assignment no close date',
  Assets_At_pos_for_ac = 'VIEW.ASSETS.At position for aircraft',

  Assignation_delete = 'VIEW.ASSETS.Delete Assignation',
  Assignation_delete_confirm = 'VIEW.ASSETS.Are you sure you want to delete this assignation ?',
  Assignation_edit = 'VIEW.ASSETS.Edit Assignation',
  Assignement_add = 'VIEW.ASSETS.Add Assignement',

  //Events
  Events_menu_title = 'NAVIGATION MENU.Events',
  Events_col_Packages = 'VIEW.EVENTS.ARRAY.Packages',
  Events_Validation = 'VIEW.EVENTS.Validation',
  Events_Set_default = 'VIEW.EVENTS.Set default',
  Events_Override_default = 'VIEW.EVENTS.Override default',
  Events_Added = 'VIEW.EVENTS.ARRAY.Added',
  Events_Export_list = 'VIEW.EVENTS.Export list',
  Events_Validation_update = 'VIEW.EVENTS.Update validation',
  Events_override_hint = 'VIEW.EVENTS.Override hint',
  Events_Name_if_empty = 'VIEW.EVENT.Event name if empty',
  Events_Desc_if_empty = 'VIEW.EVENT.Event desc if empty',
  Event_label = 'VIEW.EVENT.INFO.Event',
  Events_Triggered_already = 'VIEW.EVENT.Already triggered events',
  Events_Triggered_not = 'VIEW.EVENT.Events not triggered',
  Events_Add_label = 'VIEW.EVENT.Add events label',

  // Alerts
  Alerts_Generic_title = 'ALERT.Generic title - Alerts',
  Alerts_topBar_NewConfiguration = 'ALERT.Top bar new configuration',
  Alerts_dialog_CreateConfiguration_Title = 'ALERT.Create dialog title',
  Alerts_empty_NoConfigurations_Title = 'ALERT.Empty state title - no configurations',
  Alerts_empty_NoConfigurations_Description = 'ALERT.Empty state description - no configurations',
  Alerts_empty_NoConfigurations_Button = 'ALERT.Empty state button - create configuration',

  Alerts_dialog_SaveConfiguration_Confirm = 'ALERT.Confirm save configuration dialog',
  Alerts_dialog_DeleteConfiguration_Confirm = 'ALERT.Confirm delete configuration dialog',

  Alerts_list_Header_Name = 'ALERT.List header - name',
  Alerts_list_Header_Description = 'ALERT.List header - description',
  Alerts_list_Header_Category = 'ALERT.List header - category',
  Alerts_list_Header_Trigger = 'ALERT.List header - trigger',
  Alerts_list_Header_Status = 'ALERT.List header - status',
  Alerts_list_Status_Active = 'ALERT.List status chip - active',

  Alerts_form_Section_BasicInfo_Title = 'ALERT.Form section title - basic information',
  Alerts_form_Name_Label = 'ALERT.Form label - configuration name',
  Alerts_form_Name_Placeholder = 'ALERT.Form placeholder - configuration name',
  Alerts_form_Name_Error_Required = 'ALERT.Form error - name required',
  Alerts_form_Name_Error_MinLength = 'ALERT.Form error - name min length',

  Alerts_form_Category_Label = 'ALERT.Form label - category',
  Alerts_form_Category_NoCategories = 'ALERT.Form fallback - no categories available',
  Alerts_form_Category_Error_Required = 'ALERT.Form error - category required',

  Alerts_form_FlightType_Label = 'ALERT.Form label - flight type',

  Alerts_form_AutoResolve_Label = 'ALERT.Form label - auto resolve flight count',
  Alerts_form_AutoResolve_Placeholder = 'ALERT.Form placeholder - auto resolve flight count',
  Alerts_form_AutoResolve_Hint = 'ALERT.Form hint - auto resolve flight count',
  Alerts_form_AutoResolve_Error_Min = 'ALERT.Form error - auto resolve min value',

  Alerts_form_Description_Label = 'ALERT.Form label - description',
  Alerts_form_Description_Placeholder = 'ALERT.Form placeholder - description',

  Alerts_form_Section_Aircraft_Title = 'ALERT.Form section title - aircraft selection',
  Alerts_form_Fleets_Label = 'ALERT.Form label - fleets',
  Alerts_form_Fleets_Hint = 'ALERT.Form hint - fleets',
  Alerts_form_Aircraft_Label = 'ALERT.Form label - aircraft',
  Alerts_form_Aircraft_Hint = 'ALERT.Form hint - aircraft',
  Alerts_form_ExcludeAircraft_Label = 'ALERT.Form label - exclude aircraft',
  Alerts_form_ExcludeAircraft_Hint = 'ALERT.Form hint - exclude aircraft',

  Alerts_form_Section_Events_Title = 'ALERT.Form section title - events to monitor',
  Alerts_form_Events_Label = 'ALERT.Form label - events',
  Alerts_form_Events_Hint = 'ALERT.Form hint - events',

  Alerts_form_Section_LinkedReport_Title = 'ALERT.Form section title - linked report',
  Alerts_form_Reports_Label = 'ALERT.Form label - reports',
  Alerts_form_Reports_NoReports = 'ALERT.Form fallback - no reports available',
  Alerts_form_Reports_Hint_Inputs = 'ALERT.Form hint - report inputs',
  Alerts_form_ChartInput_Error_Required = 'ALERT.Form error - chart input value required',

  Alerts_form_Section_Trigger_Title = 'ALERT.Form section title - alert trigger',
  Alerts_form_Trigger_Header_Label = 'ALERT.Trigger header label',
  Alerts_form_Trigger_Header_Subtitle = 'ALERT.Trigger header subtitle',

  Alerts_form_AlertType_Header = 'ALERT.Trigger section header - alert type',
  Alerts_form_AlertType_Label = 'ALERT.Trigger form label - alert type',

  Alerts_form_ScoreThresholds_Header = 'ALERT.Trigger section header - score thresholds',
  Alerts_form_InfoScore_Label = 'ALERT.Trigger label - info score',
  Alerts_form_InfoScore_Hint = 'ALERT.Trigger hint - info score',
  Alerts_form_LowScore_Label = 'ALERT.Trigger label - low score',
  Alerts_form_LowScore_Hint = 'ALERT.Trigger hint - low score',
  Alerts_form_MediumScore_Label = 'ALERT.Trigger label - medium score',
  Alerts_form_MediumScore_Hint = 'ALERT.Trigger hint - medium score',
  Alerts_form_HighScore_Label = 'ALERT.Trigger label - high score',
  Alerts_form_HighScore_Hint = 'ALERT.Trigger hint - high score',

  Alerts_form_TriggerEvents_Header = 'ALERT.Trigger events header',
  Alerts_form_TriggerEvents_AddButton = 'ALERT.Trigger events button - add event',
  Alerts_form_TriggerEvents_EventTitle = 'ALERT.Trigger events title per event',
  Alerts_form_TriggerEvents_SelectedEvent_Label = 'ALERT.Trigger events small header - selected event',
  Alerts_form_TriggerEvents_EventName_Label = 'ALERT.Trigger events label - event name',
  Alerts_form_TriggerEvents_Weights_Header = 'ALERT.Trigger events small header - severity specific weights',
  Alerts_form_TriggerEvents_InfoWeight_Label = 'ALERT.Trigger events label - info weight',
  Alerts_form_TriggerEvents_LowWeight_Label = 'ALERT.Trigger events label - low weight',
  Alerts_form_TriggerEvents_MediumWeight_Label = 'ALERT.Trigger events label - medium weight',
  Alerts_form_TriggerEvents_HighWeight_Label = 'ALERT.Trigger events label - high weight',
  Alerts_form_TriggerEvents_Empty_Title = 'ALERT.Trigger events empty state text',
  Alerts_form_Snapshots_Hint = 'ALERT.Form hint - snapshots',
  Alerts_form_Snapshots_Label = 'ALERT.Form label - snapshots',
  Alerts_form_Section_Snapshots_Title = 'ALERT.Form section title - snapshots to monitor',

  // Event Groups
  Event_group_Prefix = 'VIEW.EVENT GROUP.',
  Event_group_Scores = 'VIEW.EVENT GROUP.EVENT.Scores',
  Event_groups_add_events = 'VIEW.EVENT GROUP.Add Events',
  Event_groups_add_fail = 'MESSAGE.ERROR.Unable to create Event Group',
  Event_groups_available_events = 'VIEW.EVENT GROUP.Available Events',
  Event_groups_confirm_close = 'VIEW.EVENT GROUP.Leave confirm dialog',
  Event_groups_copy_group_header = 'VIEW.EVENT GROUP.Copy Group Header',
  Event_groups_copy_group_input = 'VIEW.EVENT GROUP.Copy Group Input',
  Event_groups_delete_confirm = 'VIEW.EVENT GROUP.Delete confirm',
  Event_groups_delete_fail = 'MESSAGE.ERROR.Unable to delete Event Group',
  Event_groups_deleted = 'MESSAGE.SUCCESS.EventGroup deleted',
  Event_groups_edit_fail = 'MESSAGE.ERROR.Unable to edit Event Group',
  Event_groups_event_counts = 'VIEW.EVENT GROUP.Event Count',
  Event_groups_menu_title = 'NAVIGATION MENU.Event Groups',
  Event_groups_name = 'VIEW.EVENT GROUP.Name',
  Event_groups_new_group_header = 'VIEW.EVENT GROUP.New Group Header',
  Event_groups_new_group_input = 'VIEW.EVENT GROUP.New Group Input',
  Event_groups_new_group_input_error = 'VIEW.EVENT GROUP.New Group Input Error',
  Event_groups_non_scored = 'VIEW.EVENT GROUP.Non Scored Event Groups',
  Event_groups_not_found = 'VIEW.EVENT GROUP.Group not found',
  Event_groups_remane_group_header = 'VIEW.EVENT GROUP.Rename Group Header',
  Event_groups_rename_group_input = 'VIEW.EVENT GROUP.Rename Group Input',
  Event_groups_saved = 'MESSAGE.SUCCESS.EventGroup saved',
  Event_groups_scored = 'VIEW.EVENT GROUP.Scored',
  Event_groups_threshold_high = 'VIEW.EVENT GROUP.High Threshold',
  Event_groups_threshold_low = 'VIEW.EVENT GROUP.Low Threshold',
  Event_groups_threshold_medium = 'VIEW.EVENT GROUP.Medium Threshold',
  Event_groups_thresholds = 'VIEW.EVENT GROUP.Thresholds',
  Event_groups_title = 'VIEW.EVENT GROUP.Title',
  Events_group_Associated_events = 'VIEW.EVENT GROUP.Associated events',
  Events_group_Name_if_empty = 'VIEW.EVENT GROUP.Group name if empty',
  Events_group_Desc_if_empty = 'VIEW.EVENT GROUP.Group description if empty',
  Events_group_Non_scored = 'VIEW.EVENT GROUP.Non Scored',
  Events_group_No_trigger = 'VIEW.EVENT GROUP.No trigger',
  Events_group_Events_scored = 'VIEW.EVENT GROUP.Scored events',

  // Landing page
  Home_Welcome_text = 'VIEW.SETTINGS.LANDING PAGE.Welcome text',
  Home_Sub_text = 'VIEW.SETTINGS.LANDING PAGE.Sub text',
  Home_Back_to_page = 'VIEW.SETTINGS.LANDING PAGE.Back to page',
  Home_Aircraft_description = 'USER SETTINGS.Ac landing page',
  Home_Tags_description = 'USER SETTINGS.Tags landing page',
  Home_Users_description = 'USER SETTINGS.Users landing page',
  Home_Reports_description = 'USER SETTINGS.Reports landing page',
  Home_Assets_description = 'USER SETTINGS.Assets landing page',
  Home_Actions_description = 'USER SETTINGS.Actions landing page',
  Home_Events_description = 'USER SETTINGS.Events landing page',
  Home_Event_Groups_description = 'USER SETTINGS.Event groups landing page',
  Home_Snapshots_description = 'USER SETTINGS.Snaps landing page',
  Home_Pwi_description = 'USER SETTINGS.Pwi landing page',
  Home_Disclaimers_description = 'USER SETTINGS.disclaimer landing page',
  Home_Alerts_description = 'USER SETTINGS.Alerts landing page',
  Home_Snags_description = 'USER SETTINGS.Snags landing page',

  // PWI
  Pwi_above = 'VIEW.PWI CONFIG.Above',
  Pwi_aircraft = 'VIEW.PWI CONFIG.Aircraft',
  Pwi_aircraft_add_to_fleet = 'VIEW.PWI CONFIG.Add aircraft to fleet',
  Pwi_aircraft_already_in_fleet = 'VIEW.PWI CONFIG.Aircraft is already in fleet',
  Pwi_aircraft_no_found = 'VIEW.PWI CONFIG.No aircraft found',
  Pwi_aircraft_select_all = 'VIEW.PWI CONFIG.SelectAllAircraft',
  Pwi_aircraft_tooltip = 'VIEW.PWI CONFIG.SelectAllAircraftTooltip',
  Pwi_alias = 'VIEW.PWI CONFIG.Alias',
  Pwi_apply_to_current_list = 'VIEW.PWI CONFIG.ApplyToCurrentList',
  Pwi_below = 'VIEW.PWI CONFIG.Below',
  Pwi_contains_events = 'VIEW.PWI CONFIG.Contains events',
  Pwi_events = 'VIEW.PWI CONFIG.Events',
  Pwi_events_no_found = 'VIEW.PWI CONFIG.No events found',
  Pwi_fleet_name = 'VIEW.PWI CONFIG.Fleet Name',
  Pwi_fleet_name_invalid = 'VIEW.PWI CONFIG.Invalid Fleet Name',
  Pwi_foqa_indicators = 'VIEW.PWI CONFIG.FOQA Indicators',
  Pwi_general = 'VIEW.PWI CONFIG.General',
  Pwi_general_after_TO_date_crew = 'VIEW.PWI CONFIG.GENERAL.AfterTakeoffDateForRestOfCrew',
  Pwi_general_after_TO_date_PF = 'VIEW.PWI CONFIG.GENERAL.AfterTakeoffDateForPilotFlying',
  Pwi_general_any_event = 'VIEW.PWI CONFIG.GENERAL.AnyFlightEvents',
  Pwi_general_commemt_title = 'VIEW.PWI CONFIG.GENERAL.CommentTitle',
  Pwi_general_comment_enable = 'VIEW.PWI CONFIG.GENERAL.Enable comments',
  Pwi_general_data_available_title = 'VIEW.PWI CONFIG.GENERAL.DataAvailabilityTitle',
  Pwi_general_days_old = 'VIEW.PWI CONFIG.GENERAL.days old',
  Pwi_general_default_event_display_title = 'VIEW.PWI CONFIG.GENERAL.DefaultEventDisplayTitle',
  Pwi_general_duration = 'VIEW.PWI CONFIG.GENERAL.SetDuration',
  Pwi_general_flight_less_than = 'VIEW.PWI CONFIG.GENERAL.Flight is less than',
  Pwi_general_flight_never_opened = 'VIEW.PWI CONFIG.GENERAL.FlightWasNeverOpened',
  Pwi_general_flight_not_opened = 'VIEW.PWI CONFIG.GENERAL.AnyFlightNotOpened',
  Pwi_general_hide_events_if_opened = 'VIEW.PWI CONFIG.GENERAL.HideEventsIfSomeAreOpened',
  Pwi_general_max_corrupt_data = 'VIEW.PWI CONFIG.GENERAL.MaximumCorruptedData',
  Pwi_general_no_show_event = 'VIEW.PWI CONFIG.GENERAL.Do not show open events',
  Pwi_general_not_filled = 'VIEW.PWI CONFIG.GENERAL.GeneralNotFilled',
  Pwi_general_offset = 'VIEW.PWI CONFIG.GENERAL.SetOffset',
  Pwi_general_restrict_flight_no_valid_event = 'VIEW.PWI CONFIG.GENERAL.RestrictToFlightsNoOrValidEvents',
  Pwi_general_severity_colors = 'VIEW.PWI CONFIG.GENERAL.Snapshots Severity colors',
  Pwi_general_show_severity = 'VIEW.PWI CONFIG.GENERAL.ShowSeverity',
  Pwi_general_show_triggers = 'VIEW.PWI CONFIG.GENERAL.ShowTriggers',
  Pwi_general_to_review = 'VIEW.PWI CONFIG.GENERAL.ToReviewTitle',
  Pwi_general_unread_foqa = 'VIEW.PWI CONFIG.GENERAL.UnreadMessagesFromFOQA',
  Pwi_general_summary_email = 'VIEW.PWI.HOME.CONFIG.Summary email',
  Pwi_general_welcome = 'VIEW.PWI CONFIG.GENERAL.WelcomeMessage',
  Pwi_gradient_below_mean_value = 'VIEW.PWI CONFIG.Display the deviation Gradient Below the mean value',
  Pwi_hide_unavailable = 'VIEW.PWI CONFIG.Hide unavailable',
  Pwi_hide_unchecks = 'VIEW.PWI CONFIG.Hide unchecked',
  Pwi_max = 'VIEW.PWI CONFIG.Max',
  Pwi_menu_title = 'NAVIGATION MENU.Pilot Config',
  Pwi_min = 'VIEW.PWI CONFIG.Min',
  Pwi_new_fleet = 'VIEW.PWI CONFIG.Add new fleet',
  Pwi_no_fleet = 'VIEW.PWI CONFIG.No fleet',
  Pwi_none = 'VIEW.PWI CONFIG.None',
  Pwi_reset_config = 'VIEW.PWI CONFIG.ResetConfig',
  Pwi_same_as_event_group = 'VIEW.PWI CONFIG.SameAsEventGroups',
  Pwi_same_as_event_group_tooltip = 'VIEW.PWI CONFIG.SameAsEventGroupsTooltip',
  Pwi_save_config = 'VIEW.PWI CONFIG.SaveConfig',
  Pwi_search_by_fleet = 'VIEW.PWI CONFIG.SearchByFleet',
  Pwi_search_by_name = 'VIEW.PWI CONFIG.SearchByName',
  Pwi_search_by_registration = 'VIEW.PWI CONFIG.SearchByRegistration',
  Pwi_search_by_severity = 'VIEW.PWI CONFIG.SearchBySeverity',
  Pwi_snap_if_less_than_mean = 'VIEW.PWI CONFIG.This snapshot will be displayed only if its value is less than min',
  Pwi_snap_if_more_than_max = 'VIEW.PWI CONFIG.This snapshot will be displayed only if its value is more than max',
  Pwi_snapshots = 'VIEW.PWI CONFIG.Snapshots',
  Pwi_snapshots_text_only = 'VIEW.PWI CONFIG.This snapshot is text only',
  Pwi_title = 'VIEW.PWI CONFIG.Title',
  Pwi_Airports = 'VIEW.REPORTS.DESTINATION.Airports',
  Pwi_Flights = 'NAVIGATION MENU.Flights',

  Pwi_Conf_In_conf = 'VIEW.PWI CONFIG.In config',
  Pwi_Conf_Displayed_name = 'VIEW.PWI CONFIG.Displayed name',
  Pwi_Conf_Value_label = 'VIEW.PWI CONFIG.Value label',
  Pwi_Conf_Background_label = 'VIEW.PWI CONFIG.Background label',
  Pwi_Conf_Example_label = 'VIEW.PWI CONFIG.Example label',
  Pwi_Conf_Text_label = 'VIEW.PWI CONFIG.Text label',
  Pwi_Conf_Name_desc_hint = 'VIEW.PWI CONFIG.Pwi entity name desc edit hint',
  Pwi_Conf_Active_foqa = 'VIEW.PWI CONFIG.Active foqa',
  Pwi_Conf_No_displayed_name = 'VIEW.PWI CONFIG.No displayed name',
  Pwi_Conf_No_displayed_name_provided = 'VIEW.PWI CONFIG.Entity no display name provided',
  Pwi_Conf_No_desc = 'VIEW.PWI CONFIG.Entity no description',
  Pwi_Conf_No_event_desc_provided = 'VIEW.PWI CONFIG.Entity no desc for event hint',
  Pwi_Conf_No_desc_provided = 'VIEW.PWI CONFIG.Entity no desc hint',
  Pwi_Conf_No_associated_events = 'VIEW.PWI CONFIG.No associated events',
  Pwi_Conf_Data_viz = 'VIEW.PWI CONFIG.Data visualization',
  Pwi_Conf_Deviation_gradient = 'VIEW.PWI CONFIG.Deviation gradient display',
  Pwi_Conf_Set_limits = 'VIEW.PWI CONFIG.Set limits',
  Pwi_Conf_Included_events = 'VIEW.PWI CONFIG.Included events',
  Pwi_Conf_Same_as_default = 'VIEW.PWI CONFIG.GENERAL.Same as default',
  Pwi_Conf_Notifs = 'VIEW.PWI CONFIG.GENERAL.Notifications',
  Pwi_Conf_Flights_to_review = 'VIEW.PWI CONFIG.GENERAL.Flights to review',
  Pwi_Conf_Flights_to_review_show = 'VIEW.PWI CONFIG.GENERAL.Show flight to review',
  Pwi_Conf_Flights_never_opened = 'VIEW.PWI CONFIG.GENERAL.Flight never opened',
  Pwi_Conf_Flights_any_severity = 'VIEW.PWI CONFIG.GENERAL.Any flight with event severity',
  Pwi_Conf_Flights_never_opened_but = 'VIEW.PWI CONFIG.GENERAL.But flight never opened',
  Pwi_Conf_Flights_never_commented = 'VIEW.PWI CONFIG.GENERAL.Flight never commented',
  Pwi_Conf_Event_display = 'VIEW.PWI CONFIG.GENERAL.Event display',
  Pwi_Conf_Severity_show = 'VIEW.PWI CONFIG.GENERAL.Show severity',
  Pwi_Conf_Triggers_show = 'VIEW.PWI CONFIG.GENERAL.Show triggers',
  Pwi_Conf_Open_events_show = 'VIEW.PWI CONFIG.GENERAL.Show open events',
  Pwi_Conf_Hide_all_events = 'VIEW.PWI CONFIG.GENERAL.Hide all events until',
  Pwi_Conf_Corrupted_max_ratio = 'VIEW.PWI CONFIG.GENERAL.Corrupted max ratio',
  Pwi_Conf_For_pf = 'VIEW.PWI CONFIG.GENERAL.For pilot flying',
  Pwi_Conf_During_days = 'VIEW.PWI CONFIG.GENERAL.During days',
  Pwi_Conf_For_other_crew = 'VIEW.PWI CONFIG.GENERAL.For other crew',
  Pwi_Conf_Hours_after_to = 'VIEW.PWI CONFIG.GENERAL.Hours after TO',
  Pwi_Conf_Flights_added = 'VIEW.PWI CONFIG.GENERAL.Flight added',
  Pwi_Conf_Stats_display_foqa = 'VIEW.PWI CONFIG.STATISTICS.Display foqa stats',
  Pwi_Conf_Stats_display_if_value = 'VIEW.PWI CONFIG.STATISTICS.Display if value',
  Pwi_Conf_Stats_display_snaps = 'VIEW.PWI CONFIG.STATISTICS.Display snapshot stats',
  Pwi_Conf_Stats_display_if_unit = 'VIEW.PWI CONFIG.STATISTICS.Dispaly if unit',
  Pwi_Conf_Stats_display_aiports = 'VIEW.PWI CONFIG.STATISTICS.Display airport stats',
  Pwi_Conf_Stats_show_airports = 'VIEW.PWI CONFIG.STATISTICS.Show airport',
  Pwi_Conf_Delete_confirm = 'VIEW.PWI CONFIG.Conf delete confirm',
  Pwi_Conf_Add_conf = 'VIEW.PWI CONFIG.Add config',
  Pwi_Conf_Add_new_conf_name = 'VIEW.PWI CONFIG.Add new conf name',
  Pwi_Conf_Confirm_changes = 'VIEW.PWI CONFIG.Save conf changes confirm',
  Pwi_Conf_Label = 'VIEW.PWI CONFIG.Config label',
  Pwi_Conf_Reset_changes = 'VIEW.PWI CONFIG.Reset changes',
  Pwi_Conf_Save_conf = 'VIEW.PWI CONFIG.Save config',
  Pwi_tab_Stats = 'VIEW.PWI.MENU.Statistics',
  Pwi_tab_FOQA = 'VIEW.PWI CONFIG.FOQAs',
  Pwi_Conf_Foqa_indicator = 'VIEW.PWI CONFIG.FOQA Indicator',
  Pwi_Conf_Item_not_in_conf = 'VIEW.PWI CONFIG.Entity not in conf',
  Pwi_Conf_Foqa_created = 'VIEW.PWI CONFIG.Foqa created',
  Pwi_Conf_Same_as_foqa = 'VIEW.PWI CONFIG.Same as FOQA',
  Pwi_Conf_Ac_in_conf = 'VIEW.PWI CONFIG.Aircraft already in conf',

  // Reports & Charts
  Reports_ = 'VIEW.REPORT MANAGEMENT.',
  Reports_array_handle = 'VIEW.REPORT MANAGEMENT.ARRAY.Handle',
  Reports_array_latest_run = 'VIEW.REPORT MANAGEMENT.ARRAY.Latest run',
  Reports_array_name = 'VIEW.REPORT MANAGEMENT.ARRAY.Name',
  Reports_array_pipeline = 'VIEW.REPORT MANAGEMENT.ARRAY.Pipeline',
  Reports_array_recurrence = 'VIEW.REPORT MANAGEMENT.ARRAY.Recurrence',
  Reports_array_schedule_runs = 'VIEW.REPORT MANAGEMENT.ARRAY.Schedule Runs',
  Reports_array_type = 'VIEW.REPORT MANAGEMENT.ARRAY.Type',
  Reports_array_version = 'VIEW.REPORT MANAGEMENT.ARRAY.Version',
  Reports_array_visible = 'VIEW.REPORT MANAGEMENT.ARRAY.Visible',
  Reports_authorization = 'VIEW.REPORT MANAGEMENT.Authorization',
  Reports_default_input_values = 'VIEW.REPORT MANAGEMENT.Default Input Values',
  Reports_direct_dataset_download = 'VIEW.REPORT MANAGEMENT.Allow for direct dataset download',
  Reports_duration = 'VIEW.REPORT MANAGEMENT.Duration',
  Reports_execution_date = 'VIEW.REPORT MANAGEMENT.Execution date',
  Reports_folder_add = 'VIEW.REPORT MANAGEMENT.Add Folder',
  Reports_folder_mgmt = 'VIEW.REPORT MANAGEMENT.Folder management',
  Reports_latest_runs = 'VIEW.REPORT MANAGEMENT.LATEST RUNS',
  Reports_name = 'VIEW.REPORT MANAGEMENT.Name',
  Reports_pipeline = 'VIEW.REPORT MANAGEMENT.Pipeline',
  Reports_pipeline_mgmnt = 'VIEW.REPORT MANAGEMENT.Pipeline management',
  Reports_pipeline_params = 'VIEW.REPORT MANAGEMENT.Pipeline Parameters',
  Reports_recurrence = 'VIEW.REPORT MANAGEMENT.Recurrence',
  Reports_schedule_add = 'VIEW.REPORT MANAGEMENT.Add Schedule',
  Reports_schedule_run_only = 'VIEW.REPORT MANAGEMENT.Schedule run only',
  Reports_schedule_runs_mgmt = 'VIEW.REPORT MANAGEMENT.Schedule runs management',
  Reports_status = 'VIEW.REPORT MANAGEMENT.Status',
  Reports_users_within_permission_groups = 'VIEW.REPORT MANAGEMENT.Only users within permission groups',
  Reports_menu_title = 'NAVIGATION MENU.Reports',
  Reports_Version = 'VIEW.REPORT MANAGEMENT.Current version',
  Reports_Version_new_availabale = 'VIEW.REPORT MANAGEMENT.New version available',
  Reports_Version_updated = 'VIEW.REPORT MANAGEMENT.Version updated',
  Reports_Created = 'VIEW.REPORT MANAGEMENT.Created',
  Reports_Created_by = 'VIEW.REPORT MANAGEMENT.Created by',
  Reports_Last_mod = 'VIEW.REPORT MANAGEMENT.Last modified',
  Reports_Last_mod_by = 'VIEW.REPORT MANAGEMENT.Last modified by',
  Reports_Available_to_all = 'VIEW.REPORT MANAGEMENT.Available to all',
  Reports_Permissions = 'VIEW.REPORT MANAGEMENT.Permissions',
  Reports_Permissions_add_hint = 'VIEW.REPORT MANAGEMENT.Add permissions hint',
  Reports_Inputs = 'VIEW.REPORT MANAGEMENT.Inputs',
  Reports_Display_only = 'VIEW.REPORT MANAGEMENT.Display only',
  Reports_Run_conf = 'VIEW.REPORT MANAGEMENT.Run conf',
  Reports_Unpublish = 'VIEW.REPORT MANAGEMENT.Unpublish',
  Reports_Frequency = 'VIEW.REPORT MANAGEMENT.Frequency',
  Reports_Every = 'VIEW.REPORT MANAGEMENT.every',
  Reports_Inputs_for_run = 'VIEW.REPORT MANAGEMENT.Inputs for this run',
  Reports_Publish_date = 'VIEW.REPORT MANAGEMENT.Publication date',
  Reports_Not_published = 'VIEW.REPORT MANAGEMENT.Not published',
  Reports_Publication_title = 'VIEW.REPORT MANAGEMENT.Report Publication',
  Reports_Publish_count = 'VIEW.REPORT MANAGEMENT.Publish count',
  Reports_Handle_exists = 'VIEW.REPORT MANAGEMENT.Handle exists',
  Reports_Handle_required = 'VIEW.REPORT MANAGEMENT.Handle required',
  Reports_Name_not_empty = 'VIEW.REPORT MANAGEMENT.Name not empty',
  Reports_Publish_as_run = 'VIEW.REPORT MANAGEMENT.Publish as run',
  Reports_Publish = 'VIEW.REPORT MANAGEMENT.Publish',
  Reports_Run_conf_edit_inputs = 'VIEW.REPORT MANAGEMENT.edit run conf inputs',
  Reports_Inputs_required = 'VIEW.REPORT MANAGEMENT.Inputs value required',
  Reports_Inputs_unavailable = 'VIEW.REPORT MANAGEMENT.Input value unavailable',
  Reports_Frequency_type = 'VIEW.REPORT MANAGEMENT.Frequency type',
  Report_Reports_Run_conf_edit = 'VIEW.REPORT MANAGEMENT.Edit run conf',
  Reports_All_label = 'VIEW.REPORTS.All reports',
  Reports_Published_label = 'VIEW.REPORTS.Published reports',
  Reports_Select_one_perm = 'VIEW.REPORTS.Select one permission',
  Reports_Published_as_run = 'VIEW.REPORTS.Published as run',
  Reports_Proposed_By = 'VIEW.REPORTS.Proposed by',
  Reports_Charts_Title = 'VIEW.REPORT MANAGEMENT.Charts',
  Reports_Published_Charts = 'VIEW.REPORTS.Published charts',
  Reports_All_Charts = 'VIEW.REPORTS.All charts',
  Reports_Charts_Pending = 'VIEW.REPORTS.Charts pending publish',
  Reports_Pending_Publish = 'VIEW.REPORTS.Reports pending publish',
  Reports_Validate_publish = 'VIEW.REPORTS.Validate publish',
  Reports_Reject_publish = 'VIEW.REPORTS.Reject publish',
  Reports_Publish_Config = 'VIEW.REPORTS.Publish config',
  Reports_Err_Input_Value = 'VIEW.REPORTS.Input must have value',
  Reports_No_Input = 'VIEW.REPORTS.No inputs available',
  Reports_Charts_Menu_title = 'NAVIGATION MENU.Charts and reports',
  Reports_Charts_Reject_Hint = 'VIEW.REPORTS.Reject proposition hint',
  Reports_List_all = 'VIEW.REPORTS.List all',
  Reports_List_published = 'VIEW.REPORTS.List published',
  Reports_List_pending = 'VIEW.REPORTS.List pending',
  Reports_List_publishable = 'VIEW.REPORTS.List publishable',
  Dashboards_Title = 'VIEW.USERS.METHOD GROUPS.DASHBOARDS.Parent',
  Report_Dashboard_Title = 'NAVIGATION MENU.Reports & Dashboards',

  // Tags
  tags_content = 'VIEW.FLIGHT TAGS.Tag Content',
  tags_management = 'VIEW.ACTION TRACKING.Manage Tags',
  Tags_flight = 'VIEW.FLIGHT TAGS.Flights',
  tags_flight_count = 'VIEW.FLIGHT TAGS.Flight Count',
  Tags_flight_tags = 'VIEW.FLIGHT TAGS.Flight Tags',
  Tags_title = 'VIEW.FLIGHT.INFO.Tags',
  Tags_menu_title = 'NAVIGATION MENU.Flight Tags',
  Tags_no_created = 'VIEW.FLIGHT TAGS.No flight tags created',
  Tags_field_name = 'FIELD.FLIGHT.Tag',
  Tags_name_exists = 'VIEW.ACTION TRACKING.Tag name already exists',
  Tags_Name_already_exists = 'VIEW.FLIGHT TAGS.Tag name exists',
  Tags_Color_label = 'VIEW.FLIGHT TAGS.Color',
  Tags_Used_in = 'VIEW.FLIGHT TAGS.Used in',

  // Users
  Users = 'VIEW.USERS.METHOD GROUPS.USERS.Parent',
  Users_add = 'VIEW.USERS.Add User',
  Users_add_title = 'VIEW.USERS.NEW USER.Title',
  Users_already_exists = 'MESSAGE.ERROR.User already exists',
  Users_created = 'MESSAGE.SUCCESS.User created',
  Users_created_fail = 'MESSAGE.ERROR.Unable to create User',
  Users_created_modal = 'VIEW.USERS.NEW USER.User created modal',
  Users_created_modal_2 = 'VIEW.USERS.NEW USER.User created modal2',
  Users_delete_confirm = 'VIEW.USERS.USER.Delete confirm',
  Users_delete_fail = 'MESSAGE.ERROR.Unable to delete User',
  Users_deleted = 'MESSAGE.SUCCESS.User deleted',
  Users_email = 'VIEW.USERS.USER.Email',
  Users_email_invalid = 'VIEW.USERS.NEW USER.Email invalid',
  Users_filter = 'VIEW.USERS.USER.Filter',
  Users_gate_keeper = 'VIEW.USERS.USER.GateKeeper',
  Users_manage = 'VIEW.USERS.METHOD GROUPS.USERS.Manage Users',
  Users_me_delete_fail = 'MESSAGE.ERROR.Unable to delete yourself',
  Users_menu_title = 'NAVIGATION MENU.Users',
  Users_no_ident = 'VIEW.USERS.NEW USER.NoIdent',
  Users_password_change_error = 'MESSAGE.ERROR.Password changed error',
  Users_password_change_title = 'USER SETTINGS.Password Change',
  Users_password_current = 'USER SETTINGS.Current Password',
  Users_password_current_wrong = 'USER SETTINGS.Wrong Current Password',
  Users_password_mismatch = 'USER SETTINGS.Password mismatch',
  Users_password_new = 'USER SETTINGS.New Password',
  Users_password_new_confirm = 'USER SETTINGS.Confirm New Password',
  Users_password_policy_mismatch = 'USER SETTINGS.Policy mismatch',
  Users_password_set = 'MESSAGE.SUCCESS.Password set',
  Users_password_set_fail = 'MESSAGE.ERROR.Unable to set password',
  Users_permission_already_exists = 'VIEW.USERS.USER.Permission with same name already exists',
  Users_permission_create_new = 'VIEW.USERS.USER.New Permission',
  Users_permission_created = 'MESSAGE.SUCCESS.Permission created',
  Users_permissions_available = 'VIEW.USERS.Available permissions',
  Users_permission_delete_fail = 'VIEW.USERS.USER.Permission can not be deleted',
  Users_permission_parent = 'VIEW.USERS.METHOD GROUPS.{permission}.Parent',
  Users_permission_parent_name = 'VIEW.USERS.METHOD GROUPS.{permission}.{permissionName}',
  Users_permission_title = 'VIEW.USERS.USER.Permission',
  Users_title = 'VIEW.USERS.NEW USER.User created modal title',
  Users_username = 'VIEW.USERS.USER.Username',
  Users_user_label = 'VIEW.TARGET.ARRAY.user',

  Users_Menu_title = 'NAVIGATION MENU.Users and permissions',

  Users_Access_std = 'VIEW.USERS.ACCESS.Standard',
  Users_Access_no_ident = 'VIEW.USERS.ACCESS.No ident',
  Users_Access_gate_keeper = 'VIEW.USERS.ACCESS.Gate keeper',
  Users_Any_trigger_events_show = 'VIEW.USERS.View events any trigger',
  Users_Events_view_label = 'VIEW.USERS.TABLE.View events',
  Users_Sys_user = 'VIEW.USERS.System user',
  Users_Api_user_hint = 'VIEW.USERS.Api user only checkbox',
  Users_Api_user_label = 'VIEW.USERS.Api user only label',
  Users_Access_title = 'VIEW.USERS.TABLE.Access level',
  Users_Event_access = 'VIEW.USERS.TABLE.Events access',
  Users_No_perm = 'VIEW.USERS.TABLE.No permission',
  Users_Sys_user_only = 'VIEW.USERS.TABLE.System only',
  Users_Created_modal_bottom = 'VIEW.USERS.User_created_modal_settings',
  Users_Permission_save_delay_hint = 'VIEW.USERS.USER.Permission Save delay',
  Users_Permission_Manage_comments = 'VIEW.USERS.METHOD GROUPS.FLIGHTS.ManageComments',
  Users_Permission_Manage_View = 'VIEW.USERS.METHOD GROUPS.REPLAY.ManageViews',
  Users_filter_Gate_keeper = 'VIEW.USERS.FILTER.Gate keeper filter',
  Users_filter_Standard = 'VIEW.USERS.FILTER.Standard filter',
  Users_filter_No_ident = 'VIEW.USERS.FILTER.No ident filter',

  // Api Key Manager
  Api_key_add_ip_range = 'USER SETTINGS.Add an IP range',
  Api_key_additional_security = 'USER SETTINGS.Additional security',
  Api_key_additional_security_desc = 'USER SETTINGS.You can add an additional layer of security by adding a whitelist of IP address that will be authorized to used the API Key',
  Api_key_current = 'USER SETTINGS.Your API Key is',
  Api_key_delete = 'USER SETTINGS.Delete Key',
  Api_key_delete_confirm = 'USER SETTINGS.Are you sure you want to delete your API key ?',
  Api_key_encoded = 'USER SETTINGS.If you are using the api key as an url parameter you will need the HTTP encoded version',
  Api_key_generate = 'USER SETTINGS.Generate',
  Api_key_Ip_address = 'USER SETTINGS.IP Address',
  Api_key_latest_use = 'USER SETTINGS.Latest use of the key',
  Api_key_monitoring = 'USER SETTINGS.Monitoring',
  Api_key_no_key = 'USER SETTINGS.You do not have an API Key, click below to generate one',
  Api_key_not_used = "USER SETTINGS.Key wasn't used",
  Api_key_regenerate = 'USER SETTINGS.Regenerate Key',
  Api_key_regenerate_confirm = 'USER SETTINGS.Are you sure you want to regenerate your API key ?',
  Api_key_remove_ip_range = 'USER SETTINGS.Remove an IP range',
  Api_key_save_change_success = 'USER SETTINGS.Your changes to the whitelist were saved',
  Api_key_save_change_to_whitelist = 'USER SETTINGS.Save changes to whitelist',
  Api_key_title = 'USER SETTINGS.API KEY Management',
  Api_key_whitelist = 'USER SETTINGS.Whitelist IPs',
  Api_key_Ip_not_valid = 'USER SETTINGS.Ip not valid',
  Api_key_User_no_key = 'USER SETTINGS.User no Api Key',
  Api_key_user_key = 'USER SETTINGS.User API key',

  // Settings
  Settings = 'NAVIGATION MENU.Settings',
  Settings_lang = 'USER SETTINGS.Language',
  Settings_title = 'USER SETTINGS.Title',

  // Severity
  Severity_info = 'SEVERITY.Info',
  Severity_low = 'SEVERITY.Low',
  Severity_medium = 'SEVERITY.Medium',
  Severity_high = 'SEVERITY.High',

  // Share Configuration
  Share_config_confidential_title = 'VIEW.FLIGHT.INFO.SHARE.CONFIG.Confidential Title',
  Share_config_menu_title = 'NAVIGATION MENU.Disclaimers', //'NAVIGATION MENU.Config',
  Share_config_saved = 'VIEW.FLIGHT.INFO.SHARE.CONFIG.Saved',
  Share_config_user_input_wait = 'VIEW.FLIGHT.INFO.SHARE.CONFIG.Waiting for user inputs to stop',
  Share_config_pwi_disclaimer = 'VIEW.PWI CONFIG.Disclaimer label',
  Share_flight_default_message = 'VIEW.SHARE.Default message',

  // Snapshot
  Snapshot_add = 'VIEW.SNAPSHOT CONFIG.Add Snapshot',
  Snapshot_add_edit = 'VIEW.SNAPSHOT CONFIG.Add/Edit Snapshot',
  Snapshot_array_asset_type = 'VIEW.SNAPSHOT CONFIG.ARRAY.Asset Type',
  Snapshot_array_assrt_pos = 'VIEW.SNAPSHOT CONFIG.ARRAY.Asset Position',
  Snapshot_array_category = 'VIEW.SNAPSHOT CONFIG.ARRAY.Category',
  Snapshot_array_compare = 'VIEW.SNAPSHOT CONFIG.ARRAY.Compare',
  Snapshot_array_compare_dest = 'VIEW.SNAPSHOT CONFIG.ARRAY.Compare To Destination',
  Snapshot_array_compare_to_fleet = 'VIEW.SNAPSHOT CONFIG.ARRAY.Compare To Fleet',
  Snapshot_array_compare_to_origin = 'VIEW.SNAPSHOT CONFIG.ARRAY.Compare To Origin',
  Snapshot_array_compare_type = 'VIEW.SNAPSHOT CONFIG.ARRAY.Compare Type',
  Snapshot_array_delete = 'VIEW.SNAPSHOT CONFIG.ARRAY.Delete',
  Snapshot_array_desc = 'VIEW.SNAPSHOT CONFIG.ARRAY.Description',
  Snapshot_array_disable = 'VIEW.SNAPSHOT CONFIG.ARRAY.Disable',
  Snapshot_array_enable = 'VIEW.SNAPSHOT CONFIG.ARRAY.Enable',
  Snapshot_array_fractionnal_part = 'VIEW.SNAPSHOT CONFIG.ARRAY.Fractionnal Part',
  Snapshot_array_icon = 'VIEW.SNAPSHOT CONFIG.ARRAY.Icon',
  Snapshot_array_name = 'VIEW.SNAPSHOT CONFIG.ARRAY.Name',
  Snapshot_array_revert_changes = 'VIEW.SNAPSHOT CONFIG.ARRAY.Revert Changes',
  Snapshot_array_revert_pending_changes = 'VIEW.SNAPSHOT CONFIG.ARRAY.Revert Pending Changes',
  Snapshot_array_snap_delete = 'VIEW.SNAPSHOT CONFIG.ARRAY.Delete Snapshot',
  Snapshot_array_status = 'VIEW.SNAPSHOT CONFIG.ARRAY.Status',
  Snapshot_array_unit = 'VIEW.SNAPSHOT CONFIG.ARRAY.Unit',
  Snapshot_array_variable = 'VIEW.SNAPSHOT CONFIG.ARRAY.Variable',
  Snapshot_category_add = 'VIEW.SNAPSHOT CONFIG.Add Category',
  Snapshot_category_name = 'VIEW.SNAPSHOT CONFIG.Category Name',
  Snapshot_delete_confirm = 'VIEW.SNAPSHOT CONFIG.Are you sure you want to delete this snapshot ?',
  Snapshot_edit_categories = 'VIEW.SNAPSHOT CONFIG.Edit Categories',
  Snapshot_legend_has_change = 'VIEW.SNAPSHOT CONFIG.LEGEND.Has Changes',
  Snapshot_legend_inactive = 'VIEW.SNAPSHOT CONFIG.LEGEND.Inactive',
  Snapshot_legend_pending_deletion = 'VIEW.SNAPSHOT CONFIG.LEGEND.Pending Deletion',
  Snapshot_no_ranks_meaning_order = 'VIEW.SNAPSHOT CONFIG.No rank means alphabetical order after the numerical ranks',
  Snapshot_revert_changes = 'VIEW.SNAPSHOT CONFIG.Are you sure you want to revert the changes of this snapshot ?',
  Snapshot_rank = 'VIEW.SNAPSHOT CONFIG.Rank',
  Snapshot_row_has_change = 'VIEW.SNAPSHOT CONFIG.Row has changes',
  Snapshot_row_inactive = 'VIEW.SNAPSHOT CONFIG.Row is inactive',
  Snapshot_row_pending_deletion = 'VIEW.SNAPSHOT CONFIG.Row has pending deletion',
  Snapshot_title = 'VIEW.SNAPSHOT CONFIG.Title',
  Snapshot_menu_title = 'NAVIGATION MENU.Snapshots',
  Snapshot_label = 'VIEW.REPORT EDITOR.ITEM.COMMON.CONFIG.Snapshot',

  Snapshot_Activate = 'VIEW.SNAPSHOT.Activate',
  Snapshot_Deactivate = 'VIEW.SNAPSHOT.Dectivate',
  Snapshot_Decimals = 'VIEW.SNAPSHOT.Decimals',
  Snapshot_Example = 'VIEW.SNAPSHOT.Example snap',
  Snapshot_Colors_edit = 'VIEW.SNAPSHOT.Edit colors',
  Snapshot_Change_apply_delay = 'VIEW.SNAPSHOT.Change apply delay',
  Snapshot_No_pending_changes = 'VIEW.SNAPSHOT.No pending changes',
  Snapshot_category_label = 'VIEW.SNAPSHOT.Categories label',
  Snapshot_Name_if_empty = 'VIEW.SNAPSHOT.Snapshot name if empty',
  Snapshot_Desc_if_empty = 'VIEW.SNAPSHOT.Snapshot desc if empty',
  Snapshot_filter_Pending_changes = 'VIEW.SNAPSHOTS.FILTER.Pending changes filter',
  Snapshot_filter_Pending_deletion = 'VIEW.SNAPSHOTS.FILTER.Pending deletion filter',
  Snapshot_filter_comparable = 'VIEW.SNAPSHOTS.FILTER.Comparable filter',
  Snapshot_filter_not_comparable = 'VIEW.SNAPSHOTS.FILTER.Not comparable filter',
  Snapshot_Significantly_above_average = 'VIEW.SNAPSHOTS.Significantly above',
  Snapshot_Above_average = 'VIEW.SNAPSHOTS.Above average',
  Snapshot_Average = 'VIEW.SNAPSHOTS.Average',
  // Snags
  Snag_menu_title = 'PROFILE MENU.Snags',
  Snag_new = 'PROFILE MENU.New Snag',

  // Existing VIEW.SNAG terms from POEditor
  Snag_Title = 'VIEW.SNAG.Title',
  Snag_AddComment = 'VIEW.SNAG.Add Comment',
  Snag_InProgress = 'VIEW.SNAG.In Progress',
  Snag_ChangeStatus = 'VIEW.SNAG.Change Status',
  Snag_Closed = 'VIEW.SNAG.Closed',
  Snag_Subscribe = 'VIEW.SNAG.Subscribe',
  Snag_Unsubscribe = 'VIEW.SNAG.Unsubscribe',
  Snag_AddFile = 'VIEW.SNAG.Add File',
  Snag_SuccessCreation = 'VIEW.SNAG.Success Creation',
  Snag_SuccessEdit = 'VIEW.SNAG.Success Edit',
  Snag_Subscribed = 'VIEW.SNAG.Snag Subscribed',
  Snag_Unsubscribed = 'VIEW.SNAG.Snag Unsubscribed',
  Snag_InPlaceOf = 'VIEW.SNAG.InPlaceOf',
  Snag_All = 'VIEW.SNAG.All',
  Snag_Open = 'VIEW.SNAG.Open',
  Snag_FileUploadError = 'VIEW.SNAG.File Upload Error',
  Snag_Handle = 'VIEW.SNAG.Handle',
  Snag_Assign = 'VIEW.SNAG.Assign',
  Snag_Assigned = 'VIEW.SNAG.Snag assigned',
  Snag_Unassigned = 'VIEW.SNAG.Unassigned',
  Snag_WaitingReprocess = 'VIEW.SNAG.Waiting for reprocess',
  Snag_ChangePriority = 'VIEW.SNAG.Change Priority',
  Snag_Priority = 'VIEW.SNAG.Priority',
  Snag_RequestMoreInfo = 'VIEW.SNAG.Request for more information',
  Snag_EmptyName = 'VIEW.SNAG.Empty name',
  Snag_EmptyType = 'VIEW.SNAG.Empty type',
  Snag_invalidURL = 'VIEW.SNAG.Invalid url',
  Snag_list_hint = 'SNAG.Filter - Closed Hint',

  // VIEW.SNAG.TABLE terms
  Snag_Table_Id = 'VIEW.SNAG.TABLE.Id',
  Snag_Table_Object = 'VIEW.SNAG.TABLE.Object',
  Snag_Table_Category = 'VIEW.SNAG.TABLE.Category',
  Snag_Table_CreatedBy = 'VIEW.SNAG.TABLE.Created by',
  Snag_Table_OpenedOn = 'VIEW.SNAG.TABLE.Opened on',
  Snag_Table_ClosedOn = 'VIEW.SNAG.TABLE.Closed on',
  Snag_Table_Status = 'VIEW.SNAG.TABLE.Status',
  Snag_Table_Comments = 'VIEW.SNAG.TABLE.Comments',
  Snag_Table_Attachments = 'VIEW.SNAG.TABLE.Attachements',
  Snag_Table_Company = 'VIEW.SNAG.TABLE.Company',
  Snag_Table_AssignedTo = 'VIEW.SNAG.TABLE.Assigned To',
  Snag_Table_Priority = 'VIEW.SNAG.TABLE.Priority',

  // VIEW.SNAG.INFO terms
  Snag_Info_Snag = 'VIEW.SNAG.INFO.Snag',
  Snag_Info_OpenedOn = 'VIEW.SNAG.INFO.Opened on',
  Snag_Info_Category = 'VIEW.SNAG.INFO.Category',
  Snag_Info_Location = 'VIEW.SNAG.INFO.Location',
  Snag_Info_StatusChangedTo = 'VIEW.SNAG.INFO.Status changed to',
  Snag_Info_By = 'VIEW.SNAG.INFO.by',
  Snag_Info_CommentAddedBy = 'VIEW.SNAG.INFO.Comment added by',
  Snag_Info_AddedBy = 'VIEW.SNAG.INFO.added by',
  Snag_Info_Subscribers = 'VIEW.SNAG.INFO.Subscribers',
  Snag_Info_AssignationDate = 'VIEW.SNAG.INFO.Assignation Date',
  Snag_Info_PriorityChangedTo = 'VIEW.SNAG.INFO.Priority changed to',

  // VIEW.SNAG.INFO.TEAMWORK terms
  Snag_Teamwork_AssignedTo = 'VIEW.SNAG.INFO.TEAMWORK.Assigned To',
  Snag_Teamwork_LastUpdateDate = 'VIEW.SNAG.INFO.TEAMWORK.Last Update Date',
  Snag_Teamwork_Status = 'VIEW.SNAG.INFO.TEAMWORK.Status',
  Snag_Teamwork_Open = 'VIEW.SNAG.INFO.TEAMWORK.Open',
  Snag_Teamwork_SendToTeamwork = 'VIEW.SNAG.INFO.TEAMWORK.Send to Teamwork',

  // VIEW.SNAG.NEW terms
  Snag_New_Object = 'VIEW.SNAG.NEW.Object',
  Snag_New_RecordedUrl = 'VIEW.SNAG.NEW.RecordedUrl',
  Snag_New_Type = 'VIEW.SNAG.NEW.Type',
  Snag_New_Bug = 'VIEW.SNAG.NEW.Bug',
  Snag_New_FeatureRequest = 'VIEW.SNAG.NEW.Feature request',
  Snag_New_DataInterpretation = 'VIEW.SNAG.NEW.Problem with data interpretation',
  Snag_New_Comment = 'VIEW.SNAG.NEW.Comment',

  // VIEW.SNAG.TEAMS terms
  Snag_Teams_Support = 'VIEW.SNAG.TEAMS.Support',
  Snag_Teams_Development = 'VIEW.SNAG.TEAMS.Development',
  Snag_Teams_Production = 'VIEW.SNAG.TEAMS.Production',

  // MESSAGE.ERROR snag terms
  Snag_Error_NotFound = 'MESSAGE.ERROR.Snag not found',
  Snag_Error_UnableToCreate = 'MESSAGE.ERROR.Unable to create Snag',
  Snag_Error_UnableToLoad = 'MESSAGE.ERROR.Unable to load Snags',

  // New SNAG context terms (from our CSV)
  Snag_Button_SendToDevTeam = 'SNAG.Button - Send to Dev Team',
  Snag_Button_SentToDevTeam = 'SNAG.Button - Sent to Dev Team',

  Snag_Search_Placeholder = 'SNAG.Search - Placeholder',

  Snag_Tab_Dev = 'SNAG.Tab - Dev',
  Snag_Tab_Ideas = 'SNAG.Tab - Ideas',

  Snag_Form_EstimatedPriority = 'SNAG.Form - Estimated Priority',
  Snag_Form_SupportOwner = 'SNAG.Form - Support Owner',
  Snag_Form_OwnersSubscribers = 'SNAG.Form - Owners Subscribers',
  Snag_Form_Create = 'SNAG.Form - Create Snag',
  Snag_Form_Locations = 'SNAG.Form - Locations',
  Snag_Add_Location = 'SNAG.Add location',

  Snag_CategoryGroup_FlightAnalysis = 'SNAG.Category Group - Flight Analysis',
  Snag_CategoryGroup_SaraInterface = 'SNAG.Category Group - SARA Interface',

  Snag_Category_Events = 'SNAG.Category - Events',
  Snag_Category_Flights = 'SNAG.Category - Flights',
  Snag_Category_Parameters = 'SNAG.Category - Parameters',
  Snag_Category_ApplicationBug = 'SNAG.Category - Application Bug',
  Snag_Category_ApplicationPerformances = 'SNAG.Category - Application Performances',
  Snag_Category_UserGuide = 'SNAG.Category - User Guide',
  Snag_Category_TrainingRequest = 'SNAG.Category - Training Request',
  Snag_Category_Other = 'SNAG.Category - Other',

  Snag_Status_Read = 'SNAG.Status - Read',
  Snag_Status_SentToDev = 'SNAG.Status - Sent to Dev',
  Snag_Status_OnHold = 'SNAG.Status - On Hold',

  Snag_Tooltip_ToggleEditMode = 'SNAG.Tooltip - Toggle Edit Mode',
  Snag_Tooltip_GoToLocation = 'SNAG.Tooltip - Go to Location',

  Snag_Chat_StartConversation = 'SNAG.Chat - Start Conversation',
  Snag_Chat_Edited = 'SNAG.Chat - Edited',
  Snag_Chat_NoAttachments = 'SNAG.Chat - No Attachments',

  Snag_AttachmentsHeader_FileName = 'SNAG.Attachments Header - File Name',
  Snag_AttachmentsHeader_UploadedBy = 'SNAG.Attachments Header - Uploaded By',
  Snag_AttachmentsHeader_UploadDate = 'SNAG.Attachments Header - Upload Date',
  Snag_AttachmentsHeader_Actions = 'SNAG.Attachments Header - Actions',

  Snag_AttachmentsAria_Download = 'SNAG.Attachments Aria - Download',
  Snag_AttachmentsAria_Delete = 'SNAG.Attachments Aria - Delete',

  Snag_ListHeader_Issue = 'SNAG.List Header - Issue',
  Snag_ListHeader_Author = 'SNAG.List Header - Author',
  Snag_ListHeader_CreationDate = 'SNAG.List Header - Creation Date',
  Snag_ListHeader_LastChangeDate = 'SNAG.List Header - Last Change Date',
  Snag_ListHeader_SupportOwner = 'SNAG.List Header - Support Owner',

  Snag_List_NoData = 'SNAG.List - No Data',

  // Mail Notifications
  MailNotifs_menu_title = 'MAIL NOTIFICATIONS.Menu title',
  MailNotifs_SearchEventsNames = 'MAIL NOTIFICATIONS.Search events names',
  MailNotifs_CreateTitle = 'MAIL NOTIFICATIONS.Create title',
  MailNotifs_RecipientsPanelTitle = 'MAIL NOTIFICATIONS.Recipients panel title',
  MailNotifs_ToLabel = 'MAIL NOTIFICATIONS.To label',
  MailNotifs_AddEmail = 'MAIL NOTIFICATIONS.Add email',
  MailNotifs_CcLabel = 'MAIL NOTIFICATIONS.Cc label',
  MailNotifs_BccLabel = 'MAIL NOTIFICATIONS.Bcc label',
  MailNotifs_AircraftScope = 'MAIL NOTIFICATIONS.Aircraft scope',
  MailNotifs_AllAircrafts = 'MAIL NOTIFICATIONS.All aircrafts',
  MailNotifs_SpecificFleets = 'MAIL NOTIFICATIONS.Specific fleets',
  MailNotifs_AddAircraftFleet = 'MAIL NOTIFICATIONS.Add aircraft fleet',
  MailNotifs_SpecificAircraftRegistrations = 'MAIL NOTIFICATIONS.Specific aircraft registrations',
  MailNotifs_AddAircraftRegistration = 'MAIL NOTIFICATIONS.Add aircraft registration',
  MailNotifs_EmailContent = 'MAIL NOTIFICATIONS.Email content',
  MailNotifs_DynamicVariables = 'MAIL NOTIFICATIONS.Dynamic variables',
  MailNotifs_EmailSubject = 'MAIL NOTIFICATIONS.Email subject',
  MailNotifs_EventToMonitor = 'MAIL NOTIFICATIONS.Event to monitor',
  MailNotifs_AllInfo = 'MAIL NOTIFICATIONS.All info',
  MailNotifs_AllLow = 'MAIL NOTIFICATIONS.All low',
  MailNotifs_AllMedium = 'MAIL NOTIFICATIONS.All medium',
  MailNotifs_AllHigh = 'MAIL NOTIFICATIONS.All high',
  MailNotifs_EventField = 'MAIL NOTIFICATIONS.Event field',
  MailNotifs_RemoveAll = 'MAIL NOTIFICATIONS.Remove all',
  MailNotifs_ToError = 'MAIL NOTIFICATIONS.To error',
  MailNotifs_CcError = 'MAIL NOTIFICATIONS.Cc error',
  MailNotifs_BccError = 'MAIL NOTIFICATIONS.Bcc error',
  MailNotifs_ConfigurationNameHeader = 'MAIL NOTIFICATIONS.Configuration name header',
  MailNotifs_EventsMonitoredHeader = 'MAIL NOTIFICATIONS.Events monitored header',
  MailNotifs_AircraftMonitoredHeader = 'MAIL NOTIFICATIONS.Aircraft monitored header',
  MailNotifs_MonitoringTypeHeader = 'MAIL NOTIFICATIONS.Monitoring type header',
  MailNotifs_VariablesInstruction = 'MAIL NOTIFICATIONS.Variables instruction',
  MailNotifs_EmailTemplateVariablesTitle = 'MAIL NOTIFICATIONS.Email template variables title',

  // Widgets
  Widget_no_data = 'WIDGET.No Data',

  // Messages
  Message_email_failed = 'MESSAGE.ERROR.Email failed',
  Message_email_sent = 'MESSAGE.SUCCESS.Email sent',
  Message_error = 'MESSAGE.TITLES.Error',
  Message_info = 'MESSAGE.TITLES.Info',
  Message_warning = 'MESSAGE.TITLES.Warning',
  Messagee_success = 'MESSAGE.TITLES.Success',

  // Upload
  Uploader_menu_title = 'NAVIGATION MENU.Uploader',

  // Fields
  Field_none = 'FIELD.None',
  Field_any = 'FIELD.Any',
  Field_name = 'FIELD.EVENT.Name',
  Field_Name_original = 'VIEW.LABEL.Original name',
  Field_Names = 'VIEW.LABEL.Names',
  Field_Displayed_name = 'VIEW.LABEL.Displayed name',
  Field_Description_original = 'VIEW.LABEL.Original description',
  Field_Descriptions = 'VIEW.LABEL.Descriptions',
  Filed_Filter = 'VIEW.FILTER.Filter label',
  Field_Filters = 'VIEW.FILTER.Filters label',

  // Comparators
  Comparator_has = 'COMPARATOR.Has',
  Comparator_equals = 'COMPARATOR.Equals',
  Comparator_not_equals = 'COMPARATOR.Not Equals',
  Comparator_contains = 'COMPARATOR.Contains',
  Comparator_not_contains = "COMPARATOR.Doesn't Contain",
  Comparator_between = 'COMPARATOR.Between',
  Comparator_lower_than = 'COMPARATOR.Lower than',
  Comparator_greater_than = 'COMPARATOR.Greater than',
  Comparator_lower_eq = 'COMPARATOR.Lower or equals',
  Comparator_greater_eq = 'COMPARATOR.Greater or equals',
  Comparator_starts_with = 'COMPARATOR.Starts With',

  // Forms
  Form_required = 'FORM.Required',
  Form_superior_t0_0 = 'FORM.Superior to 0',
  Form_Global_search = 'FORM.Search global',

  // Buttons
  Button_all = 'BUTTON.All',
  Button_cancel = 'BUTTON.Cancel',
  Button_click_copy = 'BUTTON.ClickToCopy',
  Button_copy = 'BUTTON.Copy',
  Button_create = 'BUTTON.Create',
  Button_delete = 'BUTTON.Delete',
  Button_duplicate = 'BUTTON.Duplicate',
  Button_edit = 'BUTTON.Edit',
  Button_no = 'BUTTON.No',
  Button_ok = 'BUTTON.Ok',
  Button_rename = 'BUTTON.Rename',
  Button_save = 'BUTTON.Save',
  Button_yes = 'BUTTON.Yes',
  Button_add = 'BUTTON.Add',
  Button_close = 'NAVIGATION MENU.Close',
  Button_toggle_edit = 'BUTTON.Toggle edit',
  Button_name_change = 'BUTTON.Change on name',
  Button_revert_to_previous = 'BUTTON.Revert to previous',
  Button_edit_icon = 'VIEW.LABEL.Edit icon',
  Button_refresh = 'VIEW.EVENT.Refresh',
  Button_send = 'BUTTON.Send',
  Button_attach = 'BUTTON.Attach file',
  Button_download = 'VIEW.EXPORTS.ARRAY.Download',

  // Filters
  Filter_yes = 'VIEW.FILTER.Yes filter',
  Filter_no = 'VIEW.FILTER.No filter',
  Filter_true = 'VIEW.FILTER.True filter',
  Filter_false = 'VIEW.FILTER.False filter',
  Filter_inactive = 'VIEW.FILTER.Inactive filter',
  Filter_by = 'FILTER EDITOR.Filter by ',

  // Checkboxes
  Checkbox_all_expand = 'CHECKBOX.Expand all',

  // Misc
  Description = 'VIEW.TARGET.PANEL.TARGET.Description',
  From = 'USER SETTINGS.From',
  To = 'USER SETTINGS.To',
  Date = 'USER SETTINGS.Date',
  Date_Select = 'VIEW.PWI.FLIGHTS.Select date',
  Dropdown_all = 'DROPDOWN.All',
  Id = 'FIELD.FLIGHT.Id',
  Or = 'CONNECTOR.or',
  Days = 'TIME.Days',
  Active = 'VIEW.Active',
  Search = 'VIEW.FILTER.Search',
  Date_range = 'VIEW.FILTER.Date range',
  Select_all = 'VIEW.FILTER.Select All',
  All_selected = 'VIEW.FILTER.All selected',
  Already_exists = 'MESSAGE.Name exists',

  // Pagination
  Of_page = 'VIEW.PAGINATION.Of page',
  Page_next = 'VIEW.PAGINATION.Next',
  Page_prev = 'VIEW.PAGINATION.Previous',
  Page_first = 'VIEW.PAGINATION.First',
  Page_last = 'VIEW.PAGINATION.Last',
  Page_rows = 'VIEW.PAGINATION.Per page',

  // Navigation menu
  Nav_section_mgmt = 'NAVIGATION MENU.Section management',
  Nav_section_conf = 'NAVIGATION MENU.Section configuration',
  Nav_section_uploads = 'NAVIGATION MENU.Uploads',
  Nav_expand = 'NAVIGATION MENU.Expand menu',
  Nav_collapse = 'NAVIGATION MENU.Collapse menu',

  Logout = 'PROFILE MENU.Logout',
  Mesg_item_del_confirm = 'MESSAGE.CONFIRMATION.Do you really want to delete this item',
}
